<footer class="footer">
    <img alt="Infomaniak" src="/assets/images/ui/infomaniak-ethical-cloud.svg" />
    <a class="footer__gcu" href="https://www.infomaniak.com/gtl/rgpd.documents" rel="noreferrer" target="_blank">{{
        "Conditions generales d'utilisation" | transloco
    }}</a>
</footer>
